import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { IconGoogle } from "../../atoms";
import { NavListItem } from "../../molecules";

import { Nav } from "./styles";

type NavListProps = {
  onLinkClick: () => void;
};

export function NavList({ onLinkClick }: NavListProps) {
  const {
    signout,
    applicationData: { rules },
  } = useContext(AuthContext);
  const pathname = useLocation().pathname;

  const [asideModel, setAsideModel] = useState<AsideModel>([]);
  const [openGroupIndex, setOpenGroupIndex] = useState<number | null>(null);

  useEffect(() => {
    setAsideModel(rules);
  }, [rules]);

  useEffect(() => {
    // Find the index of the group that contains the current route
    const activeGroupIndex = asideModel.findIndex(
      (item) =>
        item.hasOwnProperty("group") &&
        item.group?.some(
          (subItem) => subItem.route && pathname.search(subItem.route) === 1
        )
    );
    setOpenGroupIndex(activeGroupIndex !== -1 ? activeGroupIndex : null);
  }, [pathname, asideModel]);

  const toggleGroup = (index: number) => {
    setOpenGroupIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <Nav>
      <ul>
        {asideModel.map((item, idItem) =>
          item.hasOwnProperty("group") ? (
            <li key={"item" + idItem}>
              <NavListItem.NavListButton
                expanded={openGroupIndex === idItem}
                icon={item.icon}
                text={item.text}
                onClick={() => toggleGroup(idItem)}
              />

              {openGroupIndex === idItem && (
                <ul>
                  {item.group?.map((subItem, idSubItem) => (
                    <li key={"subItem" + idSubItem}>
                      <NavListItem.NavListLink
                        to={subItem.route}
                        icon={subItem.icon}
                        text={subItem.text}
                        onClick={onLinkClick}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ) : (
            <li key={"item" + idItem}>
              <NavListItem.NavListLink
                to={item.route}
                icon={item.icon}
                text={item.text}
                onClick={onLinkClick}
              />
            </li>
          )
        )}

        <hr className="line-top" />
        <li>
          <button className="logout" onClick={signout}>
            <IconGoogle>logout</IconGoogle>
            <span>Logout</span>
          </button>
        </li>
      </ul>
    </Nav>
  );
}
